import React from 'react';
import { Utils } from '../../services';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import i18n from "i18next";

const ApplicationTypesField = ({ applicationTypes, single, name, ...rest }) => {
    const options = (applicationTypes || []).map((applicationType) => ({
        key: applicationType.id,
        text: Utils.localized_or_fallback(applicationType.name, i18n.language),
        value: applicationType.id
    }));

    return single ? (
        <SelectField name={ name } options={ options } clearable {...rest} />
    ) : (
        <MultiSelectField name={ name } options={ options } clearable {...rest} />
    );
}

export default ApplicationTypesField;
